import { render, staticRenderFns } from "./ImgRotate.vue?vue&type=template&id=1dca56ba&scoped=true&"
import script from "./ImgRotate.vue?vue&type=script&lang=js&"
export * from "./ImgRotate.vue?vue&type=script&lang=js&"
import style0 from "./ImgRotate.vue?vue&type=style&index=0&id=1dca56ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca56ba",
  null
  
)

export default component.exports